import { Employee } from './employee';
import { IUploadFile } from './file-upload';
import { ProjectActivity } from './project-activity';
import { Notification } from './notification';
import { AnnouncementRecipient } from './announcement-recipient';

export enum UserRoleEnum {
  ADMIN = 'ADMIN',
  REVIEWER = 'REVIEWER',
  PREPARER = 'PREPARER',
}

export enum UserStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type UserRole = keyof typeof UserRoleEnum;
export type UserStatus = keyof typeof UserStatusEnum;

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  role: UserRole;
  status: UserStatus;
  imagePath: string | null;
  employeeId: string | null;
  createdBy: string | null;
  updatedBy: string | null;
  deletedBy: string | null;
  createdAt: Date | string;
  updatedAt: Date | string;
  deletedAt: Date | string | null;

  employee?: Employee;
  creator?: Omit<User, 'password'>;
  updater?: Omit<User, 'password'>;
  deleter?: Omit<User, 'password'>;

  projectActivities?: ProjectActivity[];
  notifications?: Notification[];
  announcements?: AnnouncementRecipient[];
}

export type AuthUser = User;
export type IUser = Omit<User, 'password'>;

export interface BaseUser
  extends Pick<
    User,
    'firstName' | 'lastName' | 'email' | 'role' | 'status' | 'imagePath'
  > {}

export interface CreateUser
  extends BaseUser,
    Pick<User, 'password' | 'employeeId'> {}

export interface UpdateUser extends BaseUser, Pick<User, 'id'> {}

export interface DeleteUser extends Pick<User, 'id'> {}

export interface RestoreUser extends Pick<User, 'id'> {}

export interface ChangePassword {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface UpdateUserPassword extends Pick<User, 'id'> {
  newPassword: string;
  confirmPassword: string;
}

export interface UpdateCurrentUser extends Omit<BaseUser, 'role' | 'status'> {}

export interface SaveCurrentUser {
  params: UpdateCurrentUser;
  file: IUploadFile | null;
}

export type SaveUser = CreateUser | UpdateUser;

export interface UserFilter {
  query: string | null;
  role: UserRole | null;
  status: UserStatus | null;
  order: 'asc' | 'desc';
}
